<template>
  <path pid="0" d="M23.62 6.92l-3.3 3.29L19 8.92a1 1 0 00-1.41 1.41l2 2a1 1 0 001.41 0l4-4a1 1 0 000-1.41 1 1 0 00-1.38 0zM2.32 20.63a1 1 0 001-1v-2a3 3 0 013-3h7a3 3 0 013 3v2a1 1 0 102 0v-2a5 5 0 00-5-5h-7a5 5 0 00-5 5v2a1 1 0 001 1zM9.82 10.63a5 5 0 10-5-5 5 5 0 005 5zm0-8a3 3 0 11-3 3 3 3 0 013-3z"/>
</template>
